import React, { useState, forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Details, Term, Definition } from '../../common/Details'
import Freemium from '../../common/Freemium/Freemium'
import { DetailsSection } from '../DetailsSection'
import { IconListGrid, ListItemLink } from '../../common/IconListGrid'
import { Icon } from '@maui/elements'

export const MalwareAssociations = forwardRef(({ malware }, ref) => {
  const [showMalware, setShowMalware] = useState(false)
  const [showActors, setShowActors] = useState(false)
  const [showVulnerabilities, setShowVulnerabilities] = useState(false)

  const {
    actors = [],
    malware: malwareSummary = [],
    cve,
  } = malware || {}

  return (
    <DetailsSection title="Associations" ref={ref}>
      <Details>
        {!!malwareSummary?.length &&
          <>
            <Term>Malware</Term>
            <Definition>
              {malwareSummary.length &&
                <IconListGrid
                  list={malwareSummary}
                  showItems={showMalware}
                  setShowItems={setShowMalware}
                  displayLimit={12}
                  cellWidths={['100%', '50%', '33.33%', '25%']}
                  emptyMessage="There are no known malware associations at this time."
                  renderItem={(item) => (
                    <ListItemLink to={`/malware/${item.id}`}>
                      <Icon name="bug" />
                      {item.name}
                    </ListItemLink>
                  )}
                />
              }
              {malware === 'redacted' &&
                <Freemium layout="fullCenter" />
              }
            </Definition>
          </>
        }
        {!!actors?.length && (
          <>
            <Term>Actors</Term>
            <Definition>
              <IconListGrid
                list={actors}
                showItems={showActors}
                setShowItems={setShowActors}
                displayLimit={12}
                cellWidths={['100%', '50%', '33.33%', '25%']}
                emptyMessage='There are no known actor associations at this time.'
                renderItem={(item) => (
                  <ListItemLink to={`/actors/${item.id}`}>
                    <Icon name="user-secret" />
                    {item.name}
                  </ListItemLink>
                )}
              />
            </Definition>
          </>
        )}

        {!!cve?.length &&
          <>
            <Term>Vulnerabilities</Term>
            <Definition>
              {cve && Array.isArray(cve) &&
                <IconListGrid
                  list={cve}
                  showItems={showVulnerabilities}
                  setShowItems={setShowVulnerabilities}
                  type='cve'
                  displayLimit={12}
                  cellWidths={['100%', '50%', '33.33%', '25%']}
                  emptyMessage='There are no known vulnerability associations at this time.'
                  renderItem={(item) => (
                    <ListItemLink to={`/cve/${item.id}`}>
                      <Icon name="shield-alert" />
                      {item.cve_id}
                    </ListItemLink>
                  )}
                />
              }
              {cve === 'redacted' &&
                <Freemium layout="fullCenter" />
              }
            </Definition>
          </>
        }
      </Details>
    </DetailsSection>
  )
}
)

MalwareAssociations.displayName = 'MalwareAssociations'

MalwareAssociations.propTypes = {
  malwareData: PropTypes.object
}
